import api from "@/services/api";
import {
  hasManagerAccessToPath,
  isManagerOnly,
  syncLocalUserProfile,
} from "@/constants/managerAccess";
import { useCompanyStore } from "@/storePinia/company";
import { useProfileStore } from "@/storePinia/profile";

const STAFF_LIST_PATHS = [
  "/ecommerce/calendar",
  "/ecommerce/rooms-prices",
  "/ecommerce/restrictions",
  "/ecommerce/staff-rates",
  "/settings/staff",
];

let ready = null;

const load = async (localUser) => {
  const needsStaffList =
    !isManagerOnly(localUser) ||
    STAFF_LIST_PATHS.some((path) => hasManagerAccessToPath(path, localUser));

  const [profile, company, branches, staffList] = await Promise.all([
    api.myprofile.show(),
    api.company.show(),
    api.branches.list(),
    needsStaffList ? api.staff.list({ isActive: 1 }) : null,
  ]);

  if (profile?.rolesMap) {
    syncLocalUserProfile(profile, localUser);
  }
  useProfileStore().setProfile(profile);

  const storeCompany = useCompanyStore();
  storeCompany.setCompany(company);

  const branch = branches?.[0];
  if (branch) {
    storeCompany.setBranch(branch);
  }

  if (staffList) {
    storeCompany.setStaffList(staffList);
  }
};

export const startSession = (localUser) => {
  ready = load(localUser);
  return ready;
};

export const sessionReady = () => ready ?? Promise.resolve();
